import React from 'react';
import { Navigate, RouteObject } from 'react-router-dom';

import { APP_ROUTES } from '@/shared/config/routes-config';
import { UserRole } from '@/shared/enums/user-role.enum';
import { UserTeams } from '@/shared/enums/user-teams.enum';
import { RouteConfig } from '@/shared/interfaces/routes-config.interface';
import DefaultLayout from '@/shared/layouts/default/default.layout';

const MarketingPerformanceContainer = React.lazy(
  () => import('../../containers/marketing-performance/marketing-performance.container')
);

// Lead Attribution moved here from the Leads menu; the container still lives in LeadsModule.
const MarketingAttributionDashboardContainer = React.lazy(
  () =>
    import(
      '@/Modules/LeadsModule/containers/marketing-attribution-dashboard/marketing-attribution-dashboard.container'
    )
);

const MARKETING_CHILDREN = APP_ROUTES.MARKETING_MODULE.CHILDREN as RouteConfig;

export const MarketingRoutesConfig: RouteObject[] = [
  {
    index: true,
    element: <Navigate to={MARKETING_CHILDREN.PERFORMANCE.FULL_PATH} replace />
  },
  {
    // Roles mirror the marketingAnalyticsReadAccess grant in server.core.authenticator, which is
    // what the API enforces. The menu gates by role and the API by permission, so if these drift a
    // user sees the item then gets a 401.
    path: MARKETING_CHILDREN.PERFORMANCE.FULL_PATH,
    element: (
      <React.Suspense fallback={<div>Loading...</div>}>
        <DefaultLayout
          authenticationRequired={true}
          permittedList={[UserRole.ADMIN, UserRole.SUPER_ADMIN, UserRole.MARKETING_EXECUTIVE]}
          component={MarketingPerformanceContainer}
        />
      </React.Suspense>
    )
  },
  {
    // Roles and teams unchanged from the old /leads/attribution-dashboard route.
    path: MARKETING_CHILDREN.LEAD_ATTRIBUTION.FULL_PATH,
    element: (
      <React.Suspense fallback={<div>Loading...</div>}>
        <DefaultLayout
          authenticationRequired={true}
          permittedList={[
            UserRole.MARKETING_EXECUTIVE,
            UserRole.SALES_MANAGER,
            UserRole.SALES_QUALITY_MANAGER,
            UserRole.E_COMMERCE_MANAGER,
            UserRole.ADMIN
          ]}
          permittedTeamsList={[UserTeams.DIGITAL, UserTeams.E_COMMERCE]}
          component={MarketingAttributionDashboardContainer}
        />
      </React.Suspense>
    )
  }
];
